/**
 * Map menu-import API errors to user-facing i18n messages.
 * Backend logs keep technical detail; the dashboard shows friendly copy.
 */
export const mapMenuImportError = (source, detail, status, t) => {
  if (source !== "gloriafood") {
    return detail || t("status.error");
  }

  if (status === 403) {
    return t("errors.gloriafood.providerBlocked");
  }
  if (status === 504) {
    return t("errors.gloriafood.timeout");
  }
  if (status === 422) {
    if (/menu items|menu categories|empty/i.test(detail || "")) {
      return t("errors.gloriafood.menuEmpty");
    }
    if (
      /menu link|short link|company_uid|restaurant_uid|valid menu/i.test(
        detail || "",
      )
    ) {
      return t("errors.gloriafood.invalidLink");
    }
    return t("errors.gloriafood.invalidMenu");
  }
  if (status === 400) {
    if (/tracker/i.test(detail || "")) {
      return t("errors.gloriafood.invalidTracker");
    }
    return t("errors.gloriafood.invalidLink");
  }
  if (status === 502 || status === 503) {
    return t("errors.gloriafood.unavailable");
  }

  return t("errors.gloriafood.generic");
};
